<!-- confirm message modal definition -->

<div id="confirmModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      @if (title !== '') {
        <div class="modal-header">
          <h4 class="modal-title w-100 text-center" [innerHTML]="title | translate"></h4>
          <button type="button" class="ttp-btn-close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
        </div>
      }
      <div class="modal-body">
        <div class="with-icon error">
          <i class="fa fa-question-circle"></i>
          <p [innerHTML]="translateSrc | translate"></p>
        </div>
      </div>
      <div class="modal-footer">
        <div class="row justify-content-between w-100">
          <div class="col-lg-4 mb-2">
            <button id="cancelBtn" type="button" class="btn  w-100 d-block btn-default" [innerHTML]="btnNo | translate"></button>
          </div>
          <div class="col-lg-4 mb-2">
            <button id="confirmBtn" type="button" class="btn w-100 d-block btn-primary" [innerHTML]="btnYes | translate"></button>
          </div>
        </div>
      </div>
    </div><!-- /.modal-content -->
  </div><!-- /.modal-dialog -->
</div><!-- /.modal -->